/**
 * Vehicle — 차량 정보 (탕수 분류용).
 *
 * Firestore: `vehicles/{plate}` (차량번호를 doc id로 사용)
 *
 * 분류 (category):
 *   - 자차:   our_own       — 우리 회사 소유 차량
 *   - 지입차: lease         — 지입 차량 (개인 소유, 회사 등록)
 *   - 용차:   outsourced    — 임시 용차
 *   - 상차:   loading       — 상차 전용 차량
 *   - 기타:   other         — 위에 안 들어가는 등록 차량
 *
 * 등록되지 않은(또는 비활성) 차량은 전부 용차로 본다. "기타"는 등록부에 명시적으로
 * 저장된 경우에만 성립한다.
 */

export const VEHICLE_CATEGORIES = ["자차", "지입차", "용차", "상차", "기타"] as const;
export type VehicleCategory = typeof VEHICLE_CATEGORIES[number];

export interface Vehicle {
  /** Firestore doc id = 차량번호 (plate). 중복 방지 자연키 */
  id: string;
  category: VehicleCategory;
  plate: string;
  driver_name: string;
  /** YYYY-MM-DD */
  registered_at: string;
  active: boolean;
  /** 마지막 편집 시각 (감사/정렬용) */
  edited_at?: string;
  edited_by?: string;
}

export function coerceVehicle(id: string, data: Record<string, unknown>): Vehicle {
  const rawCat = typeof data.category === "string" ? data.category : "용차";
  const category: VehicleCategory =
    (VEHICLE_CATEGORIES as readonly string[]).includes(rawCat)
      ? (rawCat as VehicleCategory)
      : "용차";
  return {
    id,
    category,
    plate: typeof data.plate === "string" ? data.plate : id,
    driver_name: typeof data.driver_name === "string" ? data.driver_name : "",
    registered_at: typeof data.registered_at === "string" ? data.registered_at : "",
    active: data.active !== false, // default true (값 없거나 true면 active)
    edited_at:
      typeof data.edited_at === "string"
        ? data.edited_at
        : data.edited_at && typeof (data.edited_at as { toDate?: () => Date }).toDate === "function"
          ? (data.edited_at as { toDate: () => Date }).toDate().toISOString()
          : undefined,
    edited_by: typeof data.edited_by === "string" ? data.edited_by : undefined,
  };
}
